function getShadowRoot() {
  const host = document.querySelector('shopify-forms-embed');
  return host ? host.shadowRoot : null;
}

function fillForm() {
  const shadow = getShadowRoot();
  if (!shadow) {
    console.log('[autofill] shadow root not found yet');
    return false;
  }

  const nameField = shadow.getElementById('first_name');
  const emailField = shadow.getElementById('email');
  const orderField = shadow.getElementById('custom#order_number');

  console.log('[autofill] nameField:', nameField);
  console.log('[autofill] emailField:', emailField);
  console.log('[autofill] orderField:', orderField);

  if (!nameField || !emailField || !orderField) {
    console.log('[autofill] not all fields found yet, waiting...');
    return false;
  }

  console.log('[autofill] all fields found, filling...');
  console.log('[autofill] customerData:', window._customerData);

  if (window._customerData.name) {
    nameField.value = window._customerData.name;
    nameField.dispatchEvent(new Event('input', { bubbles: true }));
  }
  if (window._customerData.email) {
    emailField.value = window._customerData.email;
    emailField.dispatchEvent(new Event('input', { bubbles: true }));
  }
  if (window._customerData.latestOrder) {
    orderField.value = window._customerData.latestOrder;
    orderField.dispatchEvent(new Event('input', { bubbles: true }));
  }

  console.log('[autofill] done');
  return true;
}

console.log('[autofill] script loaded, _customerData:', window._customerData);

const observer = new MutationObserver(function () {
  if (fillForm()) observer.disconnect();
});

observer.observe(document.body, { childList: true, subtree: true });